
export enum LoraFormField {
  eui = 'eui',
  owner_id = 'owner_id'
}
